<template>
  <router-view v-if="configuration"
               :configuration="configuration">
  </router-view>
</template>
<script>
import sinchService from '../../services/sinchService';

export default {
  data() {
    return {
      configuration: null,
    }
  },
  computed: {
    configurationID() {
      return parseInt(this.$route.params.configurationID, 10);
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.configuration = await sinchService.getConfiguration(this.configurationID);
    }
  }
}
</script>
